export type ColorScale = Record<string, string>;

export interface ThemeText {
  primary: string;
  secondary: string;
  muted: string;
  faint: string;
}

export interface ThemeColors {
  bg: string;
  surface: string;
  card: string;
  hover: string;
  border: string;
  borderSoft: string;
  text: ThemeText;
  [family: string]: string | ColorScale | ThemeText;
}

export interface ThemePreset {
  id: string;
  name: string;
  brand: {
    primary: string;
    primaryHover: string;
    accent: string;
    logoFill: string;
    onPrimary?: string;
  };
  colors: {
    light: ThemeColors;
    dark: ThemeColors;
    overlay: { loginBg: string; loginBgDark: string; imageOverlay: string };
  };
  fonts: {
    sans: string[];
    display: string[];
    googleFontsUrl: string;
  };
  assets: {
    logo: { main: string; splash: string; favicon: string; mainDark?: string; splashDark?: string };
    backgrounds: { main: string };
    partner: { light: string; dark: string };
  };
  pwa: { name: string; shortName: string; description: string };
  shadows: { card: string; dropdown: string; logo: string };
  radii: Record<string, string>;
  zIndex: Record<string, number>;
}

export const scaleOf = (colors: ThemeColors, family: string): ColorScale =>
  colors[family] as ColorScale;

const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

export function hexToRgbArray(hex: string): [number, number, number] {
  const match = HEX.exec(hex.trim());
  if (!match) return [0, 0, 0];
  let body = match[1];
  if (body.length === 3) {
    body = body[0] + body[0] + body[1] + body[1] + body[2] + body[2];
  }
  return [
    parseInt(body.slice(0, 2), 16),
    parseInt(body.slice(2, 4), 16),
    parseInt(body.slice(4, 6), 16),
  ];
}

export function hexToRgbTriplet(hex: string): string {
  return hexToRgbArray(hex).join(" ");
}

export function hexToArgb(hex: string, alpha = "FF"): string {
  return (
    alpha +
    hexToRgbArray(hex)
      .map((n) => n.toString(16).padStart(2, "0"))
      .join("")
      .toUpperCase()
  );
}
